export const safeExtractTrackCoordinates = (track) => {
  const [, [fullCoords = []] = []] = track || [];

  return fullCoords;
};
